import { render, staticRenderFns } from "./delete-post-dialog.vue?vue&type=template&id=544ab571&"
import script from "./delete-post-dialog.vue?vue&type=script&lang=js&"
export * from "./delete-post-dialog.vue?vue&type=script&lang=js&"
import style0 from "./delete-post-dialog.vue?vue&type=style&index=0&id=544ab571&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports